'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Provider = require('../../helpers/Provider');

var _ProviderLogo = require('./ProviderLogo.scss');

var _ProviderLogo2 = _interopRequireDefault(_ProviderLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderLogo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProviderLogo, _Component);

  function ProviderLogo() {
    (0, _classCallCheck3.default)(this, ProviderLogo);
    return (0, _possibleConstructorReturn3.default)(this, (ProviderLogo.__proto__ || (0, _getPrototypeOf2.default)(ProviderLogo)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProviderLogo, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var providerLogoClassName = _ProviderLogo2.default.providerLogo + (className ? ' ' + className : '');
      var logo = (0, _Provider.getProviderLogo)(this.props.provider);
      var providerName = this.props.provider ? this.props.provider.name : '';
      return _react2.default.createElement(
        'div',
        { className: providerLogoClassName },
        logo ? _react2.default.createElement(
          'div',
          { className: _ProviderLogo2.default.logo },
          _react2.default.createElement('img', { src: logo })
        ) : _react2.default.createElement(
          'div',
          { className: _ProviderLogo2.default.providerName },
          ' ',
          _react2.default.createElement(
            'p',
            null,
            ' ',
            providerName,
            ' '
          ),
          ' '
        )
      );
    }
  }]);
  return ProviderLogo;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  provider: _react.PropTypes.object
}, _temp);
exports.default = ProviderLogo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProviderLogo/ProviderLogo.js
// module id = 1982
// module chunks = 0